<template>
  <section>
    <div class="multicount">
      <div class="entry"
           v-for="c in list.map(([,v]) => v)"
           :key="keyer(c.item)"
           :class="c.count > 0 ? 'selected' : ''">
        <span class="nom"   @click="inc(c)">{{ view(c.item) }}</span>
        <span class="count" @click="dec(c)"> {{ c.count }}</span>
      </div>
    </div>
  </section>
</template>
<script>

export default {
    // init: Counted<Item>
    props: {
    'init':{
        type: Array,
        default: () => [],
    },
    'list':{
        type: Array,
        required: true
    },
    'view':{
        type: Function,
        required: true,
    },
    'keyer':{
        type: Function,
        required: true,
    },
    'cb':{
        type: Function,
        required: true,
    },
},
    methods: {
      inc (c) { this.$emit('set-viande', c,  1) },
      dec (c) { this.$emit('set-viande', c, -1) },
    },
    data () {
      return { selection: this.init };
    }
}

</script>
<style>
  .multicount {
    margin: 0.3em;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 0.3em;
  }

  .entry {
    display: grid;
    grid-template-columns: 3fr 1fr;
    position: relative;
  }

  span:active { background-color: white; }

  .multicount .nom {
  cursor: pointer;
  display: inline-block;
  padding: 4px;
  }

.multicount .nom:hover {
    background-color: #64646408;
}

.multicount .count:hover {
    background-color: #64646408;
}

  .multicount .count {
/*  position: absolute; right:0; bottom:0; */
 cursor: pointer;
  display: inline-block;
  padding: 4px 8px;
  }
  .count:hover { background-color: cyan; }

  .entry.selected { border-bottom: thin solid deeppink; }
  .selected .nom { font-weight: bold; color: deeppink; }
  .selected .count { font-weight: bold; color: blueviolet; }

</style>
